import { useMutation } from "react-query";
import { updateOnlineDirectories } from "../../../../../actions/Utilities/OnlineDirectories";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  editStateOnlineDirectories,
  onlineDirectoriesReFetching,
} from "../atoms/atoms";
import { IOnlineDirectories } from "../types";
import { toast } from "components/toastNotification";

const useEditOnlineDirectories = () => {
  
  const setActionEditState = useSetRecoilState(editStateOnlineDirectories);
  const [isReFetching, setIsReFetching] = useRecoilState(
    onlineDirectoriesReFetching
  );

  const { mutate } = useMutation(
    (newData: IOnlineDirectories) => updateOnlineDirectories(newData),
    {
      onSuccess: (res) => {

        if (typeof res == "object") {
          toast.fire(
            "Updating Online Directories failed",
            `${res.Message}`,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Online Directory Brand Updated Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Online Directory Brand Updated Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Updating Online Directory Brand failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Updating Online Directory Brand failed ",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Updating Online Directory Brand failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire(
                "Updating Online Directory Brand failed",
                `${res}`,
                "error"
              );
          }
        }
        setActionEditState(false);
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire(
          "Update Online Directory Brand failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );
  return mutate;
};

export default useEditOnlineDirectories;
